var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictureOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-background",
    d: "M6.28474 10.6607L6.28285 10.6584C5.87152 10.1687 5.10962 10.176 4.7215 10.6979L2.23725 13.8906C2.23689 13.891 2.23652 13.8915 2.23616 13.892C1.72302 14.5454 2.17739 15.51 3.02 15.51H15.01C15.1957 15.51 15.3778 15.4583 15.5357 15.3607C15.6937 15.263 15.8214 15.1233 15.9044 14.9572C15.9875 14.7911 16.0226 14.6052 16.006 14.4202C15.9893 14.2352 15.9214 14.0586 15.81 13.91L12.3018 9.23239C12.3014 9.23194 12.3011 9.23149 12.3008 9.23105C11.9026 8.69522 11.1062 8.69305 10.7044 9.21425C10.7041 9.21455 10.7039 9.21485 10.7037 9.21515L7.98712 12.7116L6.28473 10.6607L6.28474 10.6607ZM17.5 2V16C17.5 16.8239 16.8239 17.5 16 17.5H2C1.17614 17.5 0.5 16.8239 0.5 16V2C0.5 1.17614 1.17614 0.5 2 0.5H16C16.8239 0.5 17.5 1.17614 17.5 2Z",
    stroke: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureOutlinedIcon);
export default __webpack_public_path__ + "static/media/pictureOutlinedIcon.37559b6b.svg";
export { ForwardRef as ReactComponent };